import { blipInsightsSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostNameTenant, portalDomain, messaginghubWebsocketHostName } from 'app.constants';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
export class BlipInisghtsController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'AuthenticationService', 'TenantService'];
    constructor(LoadingService, TranslateService, AccountService2, $state, AuthenticationService, TenantService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.$state = $state;
        this.AuthenticationService = AuthenticationService;
        this.TenantService = TenantService;
        this.settingsSource = blipInsightsSettingsSource;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.portalDomain = portalDomain;
        this.blipClusterUrl = blipDomainUrl;
        this.checkTenantContext = async (ContextProcessorService) => {
            this.currentTenantId = this.TenantService.getTenantPrefixFromUrl();
        };
        this.checkTenantContext(TenantService);
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.stopLoading();
    }
    async $onInit() {
        this.account = await this.AccountService2.me();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.cluster = this.blipClusterUrl.replace('https://', '').split('.')[0];
    }
}
BlipInisghtsController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'AuthenticationService', 'TenantService'];
